module.exports = __webpack_public_path__ + "img/hint-account.88bfa1dc.svg";